import {
  ENGINEER_AI_ES_BUILDER,
  ENGINEER_DRILL,
  ENGINEER_SKILL_CHECK_TOP,
  REPORT_ANALYTICS_SEARCH,
} from '../../../../config/constants/routes';

// 大学認証が完了していないユーザーには表示しないメニューのURL
// (AI選考対策 / スキルチェック / 開発ドリル / AI ESビルダー)
const STUDENT_VERIFICATION_REQUIRED_MENU_URLS = [
  REPORT_ANALYTICS_SEARCH,
  ENGINEER_SKILL_CHECK_TOP,
  ENGINEER_DRILL,
  ENGINEER_AI_ES_BUILDER,
];

export const isStudentVerificationRequiredMenu = (url: string): boolean =>
  STUDENT_VERIFICATION_REQUIRED_MENU_URLS.some((requiredUrl) =>
    url.startsWith(requiredUrl),
  );
